import { render, staticRenderFns } from "./MaskingForm.vue?vue&type=template&id=509bfaff&scoped=true"
import script from "./MaskingForm.vue?vue&type=script&lang=ts"
export * from "./MaskingForm.vue?vue&type=script&lang=ts"
import style0 from "./MaskingForm.vue?vue&type=style&index=0&id=509bfaff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509bfaff",
  null
  
)

export default component.exports